<template>
    <div class="agenda-item">
        <div class="item-wrap"
            :class="{'one-width': data.speaker.length == 1 || data.speaker.length == 0 ,'double-width':data.speaker.length == 2, 'triple-width':data.speaker.length == 3}">
            <div class="agenda-title">
                <span class="t-name">{{ data.time }}</span>
                <div class="triangle"></div>
            </div>
            <div class="a-content">
                <!-- <p class="subject-type">{{data.subject_type}} :</p> -->
                <p v-html="data.subject"></p>
                <ul>
                    <li v-for="item in data.speaker">
                        <div class="name-title">
                            <div class="name">{{item.name}}</div>
                            <div class="position">{{item.position}}</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="divider-line"> </div>
        </div>

    </div>
</template>


<script>

export default{
    props:['data','index']
}

</script>

<style lang="scss" scoped>
.agenda-item{
    margin-bottom: 30px;
    vertical-align: top;
    .item-wrap{
        min-width: 280px;
        // min-height: 120px;
        .agenda-title{
            height: 30px;
            line-height: 30px;
            position: relative;
            .t-name{
                color: #f05050;
                display: block;
                height: 30px;
                line-height: 32px;
                font-size: 24px;
            }
        }
        .a-content{
            .subject-type{
                display: inline-block;
                margin-right: 10px;
            }
            p{
                display: inline-block;
                padding: 10px 0;
                font-size: 24px;
                max-width: 380px;
                vertical-align: top;
            }
            ul{
                li{
                    padding: 0px;
                    display: inline-block;
                    list-style: none;
                    margin-bottom: 20px;
                    width: 280px;
                    .photo-wrap{
                        display: inline-block;
                        position: relative;
                        width: 98px;
                        height: 128px;
                        .photo{
                            display: block;
                            position: absolute;
                            left: 4px;
                            top: 4px;
                            z-index: 99;
                            width: 90px;
                            height: 120px;
                            vertical-align: top;
                            margin-right: 10px;
                        }
                        .left-top{
                            position: absolute;
                            width: 8px;
                            height: 8px;
                            background-color: #042745;
                        }
                        .right-bottom{
                            position: absolute;
                            width: 8px;
                            height: 8px;
                            right: 0;
                            bottom: 0;
                            background-color: #042745;
                        }
                    }
                    .name-title{
                        vertical-align: top;
                        display: inline-block;
                        width: 500px;
                        .name{
                            display: inline-block;
                            padding-top: 2px;
                            font-size: 20px;
                            margin-right: 10px;
                        }
                        .position{
                            display: inline-block;
                            font-size: 20px;
                            padding-top: 7px;
                        }
                    }
                }
            }
        }
        .divider-line{
            width: 380px;
            border-bottom: 1px solid rgba(236, 28, 36, 0.3);
        }
    }
    .one-width{
        width: 500px;
    }
    .double-width{
        width: 500px;
    }
    .triple-width{
        width: 500px;
    }
}
</style>



// WEBPACK FOOTER //
// AgendaItem.vue?34562293